define.alias("shared/components/shared/media-library", "calendar/components/shared/media-library");